import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from './table-context.js';
const tableStyles = ["table.jsx-2430604489{border:1px solid #e8edf2;background-color:#ffffff;min-width:100%;text-align:left;border-collapse:collapse;vertical-align:top;}"];
tableStyles.__hash = "2430604489";
export const Table = _ref => {
  let {
    role,
    children,
    className,
    dataTest,
    suppressZebraStriping
  } = _ref;
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      suppressZebraStriping
    }
  }, /*#__PURE__*/React.createElement("table", {
    "data-test": dataTest,
    role: role,
    className: "jsx-".concat(tableStyles.__hash) + " " + (className || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: tableStyles.__hash
  }, tableStyles)));
};
Table.defaultProps = {
  dataTest: 'dhis2-uicore-table'
};
Table.propTypes = {
  /** Should be `<TableHead>`, `<TableBody>`, and `<TableFoot>` components */
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  role: PropTypes.string,

  /** Remove the default striping on alternating rows */
  suppressZebraStriping: PropTypes.bool
};